import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuth } from '@/composables/useAuth'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./pages/Login.vue'),
    meta: { guest: true },
  },
  {
    path: '/',
    name: 'welcome',
    component: () => import('./pages/Welcome.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/file-collection',
    name: 'file_collection.index',
    component: () => import('./pages/FileCollection/Index.vue'),
    meta: { requiresAuth: true, permission: 'file-collection.view' },
  },
  {
    path: '/recursos-automatizados',
    redirect: '/file-collection',
  },
  {
    path: '/demandas',
    name: 'demands.index',
    component: () => import('./pages/Demands/Index.vue'),
    meta: { requiresAuth: true, permission: 'demands.view' },
  },
  {
    path: '/admin/users',
    name: 'admin.users.index',
    component: () => import('./pages/Admin/Users/Index.vue'),
    meta: { requiresAuth: true, permission: 'users.manage' },
  },
  {
    path: '/admin/roles',
    name: 'admin.roles.index',
    component: () => import('./pages/Admin/Roles/Index.vue'),
    meta: { requiresAuth: true, permission: 'users.manage' },
  },
  {
    path: '/admin/automation',
    redirect: '/admin/users',
  },
  {
    path: '/showcases',
    name: 'showcases.index',
    component: () => import('./pages/Showcase/Index.vue'),
    meta: { requiresAuth: true, permission: 'showcase.view' },
  },
  {
    path: '/showcases/criar',
    name: 'showcases.create',
    component: () => import('./pages/Showcase/Create.vue'),
    meta: { requiresAuth: true, permission: 'showcase.view' },
  },
  {
    path: '/showcases/:id/editar',
    name: 'showcases.edit',
    component: () => import('./pages/Showcase/Edit.vue'),
    meta: { requiresAuth: true, permission: 'showcase.view' },
  },
  {
    path: '/appeals-status-report',
    name: 'appeals_status_report.index',
    component: () => import('./pages/AppealsStatusReport/Index.vue'),
    meta: { requiresAuth: true, permission: 'appeals-report.view' },
  },
  {
    path: '/monitoring',
    name: 'monitoring.index',
    component: () => import('./pages/Monitoring/Index.vue'),
    meta: { requiresAuth: true, permission: 'monitoring.view' },
  },
  {
    path: '/pje-intake',
    name: 'pje-intake.index',
    component: () => import('./pages/PjeIntake/Index.vue'),
    meta: { requiresAuth: true, permission: 'pje-intake.upload' },
  },
  {
    path: '/transcription-intake',
    name: 'transcription_intake.index',
    component: () => import('./pages/TranscriptionIntake/Index.vue'),
    meta: { requiresAuth: true, permission: 'transcription-intake.upload' },
  },
  {
    path: '/deadline-query',
    name: 'deadline_query.index',
    component: () => import('./pages/DeadlineQuery/Index.vue'),
    meta: { requiresAuth: true, permission: 'case-deadlines.view' },
  },
  {
    path: '/activity-logs',
    name: 'activity_logs.index',
    component: () => import('./pages/ActivityLog/Index.vue'),
    meta: { requiresAuth: true, permission: 'activity-logs.view' },
  },
  {
    path: '/dashboard',
    name: 'dashboard.index',
    component: () => import('./pages/Dashboard/Index.vue'),
    meta: { requiresAuth: true, permission: 'dashboard.view' },
  },
  {
    path: '/lawsuits/add',
    name: 'lawsuits.add',
    component: () => import('./pages/Lawsuit/Add/Index.vue'),
    meta: { requiresAuth: true, permission: 'lawsuits.view' },
  },
  {
    path: '/lawsuits/appeals/import-deadlines',
    name: 'lawsuits.appeals.import_deadlines',
    component: () => import('./pages/Lawsuit/Appeals/ImportDeadlines/Index.vue'),
    meta: { requiresAuth: true, permission: 'deadlines.import' },
  },
  {
    path: '/lawsuits',
    name: 'lawsuits.index',
    component: () => import('./pages/Lawsuit/Index/Index.vue'),
    meta: { requiresAuth: true, permission: 'lawsuits.view' },
  },
  {
    path: '/lawsuits/legacy',
    name: 'lawsuits.legacy',
    component: () => import('./pages/Lawsuit/Legacy/Index.vue'),
    meta: { requiresAuth: true, permission: 'lawsuits.view' },
  },
  {
    path: '/lawsuits/:id',
    name: 'lawsuits.show',
    component: () => import('./pages/Lawsuit/Show/Index.vue'),
    meta: { requiresAuth: true, permission: 'lawsuits.view' },
  },
  {
    path: '/notifications',
    name: 'notifications.index',
    component: () => import('./pages/Notification/Index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/projeto/:slug',
    name: 'showcases.show',
    component: () => import('./pages/Showcase/Show.vue'),
    meta: { requiresAuth: true, permission: 'showcase.view' },
  },
  {
    path: '/testes/transcricao-ia',
    name: 'testes.transcricao_ia',
    component: () => import('./pages/Testes/TranscricaoIa/Index.vue'),
    meta: { requiresAuth: true, permission: 'showcase.view' },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  const { user, can } = useAuth()

  if (to.meta.requiresAuth && !user.value) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  const required = to.meta.permission as string | undefined
  if (required && !can(required)) {
    return { path: '/' }
  }

  if (to.meta.guest && user.value) {
    return { path: '/' }
  }
})
